import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";

import { createAppRouter } from "@/router";

import "@fontsource-variable/inter/wght.css";
import "@fontsource/geist-mono/400.css";
import "@/styles/globals.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Missing #root");
}

const router = createAppRouter();

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
